function parseTaxRate(value) {
  if (value == null || value === '') return 0;

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return 0;

    if (trimmed.includes('%')) {
      const percent = Number(trimmed.replace('%', ''));
      return Number.isFinite(percent) ? percent / 100 : 0;
    }

    const numeric = Number(trimmed);
    if (!Number.isFinite(numeric)) return 0;
    return numeric > 1 ? numeric / 100 : numeric;
  }

  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return numeric > 1 ? numeric / 100 : numeric;
}

export function hasProjectSalesTaxAssigned(project) {
  if (!project) return false;

  if (parseTaxRate(project?.taxLocation?.tax) > 0) return true;
  if (parseTaxRate(project?.taxLocation?.rate) > 0) return true;

  const salesTaxRate = project?.salesTaxRate;
  if (typeof salesTaxRate === 'string') {
    return salesTaxRate.trim() !== '';
  }

  return salesTaxRate != null && salesTaxRate !== 0;
}
